module.exports = __webpack_public_path__ + "files/8152e53c5fabc45b93bf85c00e0a6b2f.png";